import React from "react"
import { accessFromProps } from "../lib/book-access"
import { BookShell } from "../components/book-shell"
import { PageHeader } from "../components/page-header"
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"

export function ModulePage(props) {
  const {
    module_name,
    active_slug,
    user_name,
    access_role,
    can_create_company,
    can_enter_transactions,
    can_approve_documents,
    can_manage_company_settings,
    is_viewer,
  } = props

  const access = accessFromProps(props)
  return (
    <BookShell activeSlug={active_slug} userName={user_name} access={access}>
      <div className="flex flex-col gap-6">
        <PageHeader title={module_name} />
        <Card>
          <CardHeader>
            <CardTitle>Module scaffold ready</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm leading-relaxed text-muted-foreground">
              {module_name} is ready for data models, listing pages, and create/update workflows.
            </p>
          </CardContent>
        </Card>
      </div>
    </BookShell>
  )
}
